import React from 'react';
import logoWordmark from '../../../static/logo-wordmark.png';

const Preloader = () => (
  <div className="preloader">
    <svg className="logo-symbol" viewBox="0 0 210 216">
      <g>
        <g>
          <path className="st0" d="M189.05,98.72c-0.78-1.87-1.66-3.65-2.62-5.36C175,73.12,151.1,64.49,128.9,64.41
		c-3.46-0.01-6.92,0.19-10.36,0.59c-1.42,0.17-10.8,0.83-11.23,2.05c3.64-10.32,4.1-19.59,1.33-27.56
		C105.37,30.08,96.82,23,85.76,20.57c-2.9-0.64-5.77-1-8.54-1.08C65,19.15,54.31,24.16,45.47,34.38
		C36.43,44.83,31.68,58,29.25,67.51c-0.08-0.03-0.15-0.05-0.23-0.08c-0.4-0.13-0.83-0.2-1.26-0.21c-1.92-0.05-3.96,1.08-4.96,2.76
		c-1.1,1.85-1.08,4.05-1.06,5.79c-0.18,4.68-0.25,9.41-0.21,14.08c0.34,38.92,8.76,57.86,8.84,58.05l1.33-0.22l-0.03-1.83
		c-3.83-36.89,0.72-68.59,13.51-94.22c3.66-7.34,8.27-12.62,14.95-17.14c8.63-5.83,21.13-8.23,29.54-0.72
		c8.65,7.72,7.08,21.12,3.29,30.94c-2.48,6.43-6.64,12.1-12.04,16.38c-0.48,0.38-0.97,0.75-1.46,1.11
		c-0.58,0.37-1.19,0.74-1.82,1.12c-5,3.05-11.22,6.84-8.69,12.16c0.2,0.41,0.47,0.78,0.79,1.07c1.56,1.4,3.99,1.94,6.14,2.42
		l1.08,0.24c1.43,0.33,5.02,1.17,7.56,1.36c-16.54,10.96-27.89,24.26-33.74,39.55l1.2,0.56c14.95-16.3,48.11-33.55,58.39-37.01
		c0.73-0.27,1.39-0.5,1.99-0.69c1.51-0.5,2.56-0.78,2.94-0.88l0.17-0.04c4.35-1.02,6.83-4.8,5.65-8.61
		c-0.88-2.85-3.97-4.96-7.68-5.23L96.15,86.9c0.21-0.25,0.54-0.64,0.54-0.64s2.99-3.52,9.15-6.82c0.11-0.05,0.2-0.09,0.32-0.14
		c9.07-4.21,20.92-5.04,30.77-3.95c11.98,1.32,23.53,6.41,30.97,16.08c6.38,8.29,9.68,18.6,9.61,29.03
		c-0.08,13.56-5.66,26.72-14.7,36.74c-18.05,20.02-52.62,27.16-78.97,27.16c-1.47,0-2.95-0.02-4.41-0.06
		c-11.1-0.31-21.75-1.78-31.66-4.38l-4.26-1.24l-0.48,1.11c18.27,6.78,36.36,10.46,53.77,10.95c2.96,0.08,5.94,0.07,8.85-0.03
		c22.61-0.82,43.66-7.51,59.28-18.83C187.42,155.58,200.23,125.4,189.05,98.72z"/>
        </g>
      </g>
    </svg>
    <img alt="My Breakup Registry logo wordmark" src={logoWordmark} />
  </div>
);

export default Preloader;
